import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/useAuth';
import { FullPageSpinner } from '@/components/ui/Spinner';
import { Alert } from '@/components/ui/Alert';
import { ROUTES, spaceRouteForRole } from '@/config/navigation';
import type { UserRole } from '@/types/domain';

/**
 * Restreint une branche de routes a un ou plusieurs roles.
 * Meme remarque que RequireAuth : confort d'interface, la securite est en base.
 */
export function RequireRole({ allow }: { allow: UserRole[] }) {
  const { isLoading, isAuthenticated, role, profileError } = useAuth();

  if (isLoading) return <FullPageSpinner />;
  if (!isAuthenticated) return <Navigate to={ROUTES.signIn} replace />;

  // Session valide mais profil illisible : cas normal tant que la Phase 2
  // (migrations + RLS) n'a pas ete appliquee. On explique au lieu de rediriger
  // en boucle vers la page de connexion.
  if (!role) {
    return (
      <div className="cf-container py-10">
        <Alert tone="warning" title="Profil introuvable">
          <p>
            La session est valide mais aucun profil n’a pu être chargé. C’est attendu tant que les
            migrations de la Phase 2 n’ont pas été appliquées à votre projet Supabase.
          </p>
          {profileError && <p className="mt-2 font-mono text-xs opacity-80">{profileError}</p>}
        </Alert>
      </div>
    );
  }

  if (!allow.includes(role)) {
    return <Navigate to={spaceRouteForRole(role)} replace />;
  }

  return <Outlet />;
}
